import React from 'react';

export default function Nav({ current, onNav }) {
  const links = [
    {id:'home', label:'Home'},
    {id:'about', label:'About Us'},
    {id:'admissions', label:'Admissions'},
    {id:'academics', label:'Academics'},
    {id:'facilities', label:'Facilities'},
    {id:'gallery', label:'Gallery'},
    {id:'news', label:'News & Events'},
    {id:'contact', label:'Contact Us'},
  ];
  return (
    <div className="nav">
      <div className="container">
        <div className="nav-inner">
          {links.map(l => (
            <div key={l.id} className={`nav-link${current===l.id?' active':''}`} onClick={() => onNav(l.id)}>{l.label}</div>
          ))}
          <button className="nav-enquire" onClick={() => onNav('contact')}>Enquire Now</button>
        </div>
      </div>
    </div>
  );
}
